import { Route } from '@angular/router';
import { PrincipalComponent, SignInComponent } from '@formulando-frontend/shared';
import { canActivate, redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['sign-in']);
const redirectLoggedInToApp = () => redirectLoggedInTo(['']);

export const appRoutes: Route[] = [
  { path: 'sign-in', component: SignInComponent, ...canActivate(redirectLoggedInToApp) },
  { path: '', component: PrincipalComponent, ...canActivate(redirectUnauthorizedToLogin) },
  { path: '**', redirectTo: '' },
];
